import { getGeoValueByType } from '@/packages/JsonQuery';
import { type IJsonQueryHighway } from '@/packages/api-models/common/json_query';

import { type IHighway, type IHighwayDirection } from '../../../../../types/highways';
import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagWithIdSchema } from '../types';

export const geoHighway: ITagGroupConfig = {
  get({ jsonQuery, highways: directions, geoTags }) {
    let highwayIds: number[] = getGeoValueByType<IJsonQueryHighway>('highway')(jsonQuery)?.map(item => item.id) || [];

    if (highwayIds.length === 0) {
      return null;
    }

    const { highwaysMap, directionsMap } = getHighwayMap(directions);

    const tagsGroup: TagWithIdSchema[] = [];

    while (highwayIds.length > 0) {
      const id = highwayIds[0];
      /**
       * если все станции направления есть в выбранных станциях, то удаляем их из выбранных
       * тк в этом случае будет добавлен общий тег для направления
       * @see geoHighwayDirection
       */
      if (
        directionsMap[highwaysMap[id]?.direction]?.every(directionHighwayId =>
          highwayIds.some(selectedId => selectedId === directionHighwayId),
        )
      ) {
        highwayIds = highwayIds.filter(
          selectedHighWayId => !directionsMap[highwaysMap[id]?.direction]?.includes(selectedHighWayId),
        );

        continue;
      }

      const tagData = highwaysMap[id]?.highway ??
        geoTags.highway.find(({ id: tagId }) => tagId === id) ?? {
          name: `Неизвестное шоссе #${id}`,
          fullName: `Неизвестное шоссе #${id}`,
          id,
        };

      tagsGroup.push({
        group: 'geoHighway',
        text: tagData.name,
        data: tagData.id,
      });

      highwayIds = highwayIds.slice(1);
    }

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ onChange }, tag: TagWithIdSchema) {
    onChange({
      action: 'removeGeo',
      arguments: [{ type: 'highway', id: tag.data }],
    });
  },
};

function getHighwayMap(directions: IHighwayDirection[]): {
  highwaysMap: Record<number, { highway: IHighway; direction: string }>;
  directionsMap: Record<string, number[]>;
} {
  const highwaysMap: { [id: number]: { highway: IHighway; direction: string } } = {};
  const directionsMap: { [name: string]: number[] } = {};

  for (const direction of directions) {
    directionsMap[direction.name] = [];

    for (const highway of direction.highways) {
      highwaysMap[highway.id] = { highway, direction: direction.name };
      directionsMap[direction.name].push(highway.id);
    }
  }

  return { highwaysMap, directionsMap };
}
